import isNil from 'lodash/isNil'
import populate from 'coact/populate'


const stringToLength = (value, len, ch) => {
  const lenth = parseInt(len, 10)
  let character = ch
  if (ch === undefined) character = ' '

  let i
  let str = value
  for (i = str.length; i < len; i++) {
    str = character + str
  }
  return str.slice(0, lenth)
}

const toLen = (num, len, ch) => {
  const str = `${''}${num}`
  return stringToLength(str, len, ch)
}

const diopterToDegree = function (value) {
  const floatValue = parseFloat(value)
  if (isNaN(floatValue)) return ''
  if (floatValue > 0 && floatValue < 1) return `+${toLen(parseInt(floatValue * 100, 10), 3, '0')}`
  else if (floatValue >= 1) return `+${parseInt(floatValue * 100, 10)}`
  else if (floatValue < 0 && floatValue > -1) {
    return `-${toLen(parseInt(floatValue * -100, 10), 3, '0')}`
  } else if (floatValue <= -1) return `-${parseInt(floatValue * -100, 10)}`
  else if (floatValue === 0) return '+000'
  return floatValue
}

const isBlank = function (value) {
  return value === undefined || value === '' || value === null
}

export default next => async (ctx) => {
  const { method } = ctx
  if (method === 'GET') return next(ctx)

  const { values } = ctx

  const type = isNil(values.type) ? '' : values.type
  const material = isNil(values.material) ? '' : values.material
  const modelviews = ctx.modelviews
  const products = modelviews.model('products')
  // // (Methods I: Deep copy values before populate)
  // const valuesCopied = values

  const populatedProducts = await populate(modelviews, products.schema(), values)
  // const def.
  const S_PRODUCT_A = 'A'
  // const S_PRODUCT_B = 'B'
  const S_PRODUCT_C = 'C'

  const brand = isNil(populatedProducts.brandRef) ? '' : populatedProducts.brandRef.key
  const brandCode = brand.split('-')[0]
  const brandName = brand.slice(brand.indexOf('-') + 1, brand.length)
  const productModel = values.model
  const colorCode = values.colorCode
  // const materialName = (material.split('-')[1]) ? material.split('-')[1] : material.split('-')[0]
  const materialName = material.split('-')[1]
  const rimType = isNil(values.rimType) ? '' : values.rimType
  const rimTypeName = rimType.split('-')[1]
  const colorName = isNil(populatedProducts.colorRef) ? null : populatedProducts.colorRef.key
  const contour = isNil(values.contour) ? '' : values.contour
  const contourName = contour.split('-')[1]
  // const orderCode = values.orderCode

  values.brandCode = brandCode
  // values.brandName = brandName

  // const refractiveIndex = values.refractiveIndex
  // const design = values.design
  // const coating = values.coating
  // const storageType = values.storageType
  const s = diopterToDegree(values.sphereMax)
  const s2 = diopterToDegree(values.sphereMin)
  const c = diopterToDegree(values.cylinderMax)
  // const c2 = diopterToDegree(values.cylinderMin)
  const sc = diopterToDegree(values.SCMax)
  const sc2 = diopterToDegree(values.SCMin)
  const a = values.axisMax
  const add = values.addMax

  const replacementFrequencyToName = {
    1: '日拋',
    14: '雙週拋',
    30: '月拋',
    60: '雙月拋',
    90: '季拋',
    365: '年拋',
  }
  const series = isNil(populatedProducts.seriesRef) ? '' : populatedProducts.seriesRef.key
  const replacementFrequency = isNil(values.replacementFrequency) ?
    null :
    replacementFrequencyToName[values.replacementFrequency.toString()]
  const radius = values.radius
  const packingQuantity = values.packingQuantity
  const lensColor = values.lensColor

  // generateKey
  switch (type) {
    case S_PRODUCT_A :
      values.key = [brandCode, productModel, colorCode].join('-')
      break

    // case S_PRODUCT_B :
    //   values.key = [brandCode, orderCode].join('-')
    //   break
    default:
  }


  // generateName

  switch (type) {
    case S_PRODUCT_A :
      values.name = [
        brandName,
        productModel,
        materialName,
        rimTypeName,
        colorName,
        contourName,
      ].join('-')
      break

    // case S_PRODUCT_B :
    //   values.name = [brandName, refractiveIndex, design, coating, storageType].join('-')
    //   if (s !== '') values.name += ` S${s}`
    //   if (s2 !== '') values.name += `${s2}`
    //   if (c2 !== '') values.name += ` C${c2}`
    //   if (sc !== '') values.name += ` S+C${sc}`
    //   if (sc2 !== '') values.name += `${sc2}`
    //   break

    case S_PRODUCT_C :
      values.name = [
        brandName,
        series,
        replacementFrequency,
        radius,
        `${packingQuantity}片裝`,
        lensColor,
      ].join('-')
      if (s !== '') values.name += ` S${s}`
      if (s2 !== '' && s !== s2) values.name += `${s2}`
      if (c !== '') values.name += ` C${c}`
      if (sc !== '') values.name += ` S+C${sc}`
      if (sc2 !== '') values.name += `${sc2}`
      if (!isBlank(a)) values.name += ` A${a}`
      if (!isBlank(add)) values.name += ` ${add}`
      break
    default:
      console.log('no type was selected')
  }
  // assign _ids to Ref fields (Methods II: assign _id to Ref fields before return next)
  values.lensTypeRef = (values.lensTypeRef) ? values.lensTypeRef._id : null
  values.colorRef = (values.colorRef) ? values.colorRef._id : null
  values.supplierRef = (values.supplierRef) ? values.supplierRef._id : null
  values.brandRef = (values.brandRef) ? values.brandRef._id : null
  values.seriesRef = (values.seriesRef) ? values.seriesRef._id : null

  return next(ctx)
}



// WEBPACK FOOTER //
// ./src/views/middlewares/fillProductKey.js